/* @flow */
import React from 'react';

import TBody from 'components/UIKit/Table/TBody';
import TransactionsRow from './TransactionsRow';

import type { Transactions } from 'models/transactions';

type TransactionsRowsProps = {
  children: Transactions,
  router: Object
}

let TransactionsRows = ({
  children, router
}: TransactionsRowsProps): React.Element => (
  TBody({
    children: children.map((transaction, i) => (
      <TransactionsRow i={i} key={transaction.id} router={router}>{transaction}</TransactionsRow>
    ))
  })
);

export default TransactionsRows;
